import UdeskLocales from 'UdeskLocales';
import React, { FC, useState } from 'react';
import { useRequest } from 'ahooks';
import styled from 'styled-components';
import { Input, Spin, Tabs } from 'udesk-ui';
import FieldList, { TemplateProps as FieldListProps } from './components/FieldList';
import { postFieldDataSearchTemplate } from 'src/api/field/data/search-template';
import { DataSources } from './const';
import { FieldFoundAdvanceWrapperResponse } from 'src/api/types';

const Wrapper = styled.div`
    min-width: 0;
    width: 280px;
    flex: 280px 0 0;
    border: 1px solid #d9d9d9;
    padding: 20px;

    .udesk-qa-ui-input {
        border-color: #d9d9d9 !important;
    }
`;

interface TemplateProps {
    onChooseField?: FieldListProps['onChooseField'];
    typeList?: number[];
}

const Template: FC<TemplateProps> = (props) => {
    const { typeList, onChooseField } = props;

    const [activeKey, setActiveKey] = useState<string>(`${DataSources[0].id}`);

    const [queryData, setQueryData] = useState<FieldFoundAdvanceWrapperResponse[]>();

    const { data, loading } = useRequest(
        () =>
            postFieldDataSearchTemplate({
                sourceList: DataSources.map((d) => d.id),
                typeList: typeList || [],
            }),
        {
            onSuccess: (res) => {
                setQueryData(res.data);
            },
        }
    );

    const onSearch = (value?: string) => {
        setQueryData(
            value
                ? data?.data?.map((d) => {
                      return {
                          ...d,
                          typeList: d.typeList?.map((t) => {
                              return {
                                  ...t,
                                  fieldList: t.fieldList?.filter((f) =>
                                      f.label?.toLowerCase()?.includes(value.toLowerCase())
                                  ),
                              };
                          }),
                      };
                  })
                : data?.data
        );
    };

    return (
        <Wrapper>
            <Tabs
                size="small"
                tabBarExtraContent={
                    <Input.Search
                        placeholder={
                            /* 请输入关键词查询 */ UdeskLocales['current'].components
                                .variableFieldSelect.index.pleaseEnterAKeywordQuery
                        }
                        style={{ width: 100 }}
                        size="small"
                        onSearch={onSearch}
                    />
                }
                activeKey={activeKey}
                onChange={(key) => setActiveKey(key)}
            >
                {DataSources.map((d) => (
                    <Tabs.TabPane tab={d.name} key={`${d.id}`}></Tabs.TabPane>
                ))}
            </Tabs>

            <div style={{ height: '300px', overflowY: 'auto' }}>
                <Spin spinning={loading}>
                    <FieldList
                        queryData={queryData}
                        inspectDataSource={Number(activeKey)}
                        onChooseField={onChooseField}
                    />
                </Spin>
            </div>
        </Wrapper>
    );
};

export default Template;
